export default () => {
  // Contact, Account pages
  $(document).on('click touchend', '[data-chat-widget]', () => {
    $('#gladlyChat_container').addClass('visible');
    if (typeof window.Gladly !== 'undefined') {
      window.Gladly.show();
    }
  });

  // [ADA]
  document.querySelectorAll('[data-chat-widget]').forEach((chatLink) => {
    chatLink.addEventListener('keypress', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        chatLink.click();
      }
    });
  });

  // Pre-header
  $(document).on('click touchend', '[data-chat-nav]', () => {
    $('#gladlyChat_container').addClass('visible');
    if (typeof window.Gladly !== 'undefined') {
      window.Gladly.show();
    }
  });

  $(document).on('click touchend', '#gladlyChat_container [aria-label="close"]', () => {
    $('#gladlyChat_container').removeClass('visible');
  });

  $(document).on('focusin', '[data-chat-nav]', () => {
    $('#accountNav').removeClass('keep-opened');
  });

  // [ADA]
  document.querySelectorAll('[role="menuitem"]').forEach((menuItem) => {
    menuItem.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        menuItem.click();
      }
    });
  });
};
